export type PossibleTypesResultData = {
  possibleTypes: {
    AdditionalSignupQuestion: ['AdditionalSignupQuestionSimple']
    AfterAppLoadScreen: ['AfterAppLoadGetStartedScreen', 'AfterAppLoadSignupFormScreen']
    AssessmentGraphSeries: ['Gad7Series', 'Phq9Series']
    AvailableVideoCallSlotsResult: ['AvailableVideoCallSlots', 'VideoCall']
    CancelPlanForm: ['CancelPlanScreenReasonsToCancel', 'CancelPlanScreenUserFeedback']
    CancelVideoCallByParticipantResult: ['InAppVideoCallResult']
    CoachAvailabilityResult: ['CoachAvailability', 'VideoCall']
    CommunityPost: ['CommunityPostQuestion']
    CommunityPostReply: ['CommunityPostReplyQuestionAnswer']
    CommunityPostReplyAuthor: ['CommunityFacilitator']
    CommunityPostReplyResult: ['CommunityPostReplySended', 'CommunityPostReplySendingPrevented']
    CostEstimateLookup: ['CostEstimateLookupFailure', 'CostEstimateLookupSuccess']
    CreateChatMessageResult: ['ChatMessageCreated']
    EditChatMessageResult: ['ChatMessageEdited']
    FeedItem: [
      'ChatMessage',
      'LabOrderEvent',
      'OverdueQuestionnaire',
      'PatientResponse',
      'ResumedPatientResponse',
      'SmsMessage',
      'VideoCall'
    ]
    FeedResult: ['FeedSuccess']
    InAppCancelPlanResult: ['InAppCancelPlanScreen', 'InAppPlanCancelledScreen']
    InAppCostEstimateComponent: [
      'InAppCostEstimateAlertComponent',
      'InAppCostEstimateExpandableComponent',
      'InAppCostEstimateFeeGroupComponent',
      'InAppCostEstimateHorizontalDividerComponent',
      'InAppCostEstimateIconTextListComponent',
      'InAppCostEstimateMultiTextInRowComponent',
      'InAppCostEstimateParagraphComponent',
      'InAppCostEstimateTimelineComponent',
      'InAppCostEstimateTitleComponent'
    ]
    InAppPaymentInformation: ['AllPaymentsCompleted', 'PaymentSummary', 'UpcomingPayment']
    InAppProfileFormInputField: [
      'InAppProfileFormCheckbox',
      'InAppProfileFormMultiItemSelector',
      'InAppProfileFormProviderIdentifier',
      'InAppProfileFormSingleItemSelector',
      'InAppProfileFormTextInput'
    ]
    InAppProfileFormItemSelector: [
      'InAppProfileFormMultiItemSelector',
      'InAppProfileFormProviderIdentifier',
      'InAppProfileFormSingleItemSelector'
    ]
    InAppPromptActionPanelActionButton: ['InAppPromptActionPanelActionButtonDeepLink']
    InAppSignupFormResult: ['InAppSignupFormFound', 'InAppSignupFormNotFound']
    MarkChatMessagesAsSeenResult: ['UnseenChatMessages']
    ParticipantRegistrationResult: ['ParticipantRegistered', 'ParticipantRegistrationFailed']
    PatientHistory: [
      'CommonPatientHistory',
      'FinancialEligibilityPatientHistory',
      'LabOrderPatientHistory',
      'VideoCallPatientHistory'
    ]
    PatientResponseSectionEntryContext: ['PatientResponseSectionEntryContextSingleChoice']
    PaymentMethod: ['PaymentMethodCreditCard']
    RescheduleVideoCallByParticipantResult: ['OpenScheduleVideoCallLesson']
    ScheduleVideoCallByParticipantResult: ['VideoCall', 'VideoCallSlotTaken']
    SignupFormInput: [
      'SignupFormConsents',
      'SignupFormDateSelector',
      'SignupFormEmailInput',
      'SignupFormItemSelector',
      'SignupFormPhoneNumberInput',
      'SignupFormTextInput'
    ]
    SignupFormScreen: ['SignupFormIsDependentScreen', 'SignupFormRegularScreen']
    StorePaymentMethodResult: ['StorePaymentMethodResultSuccess']
    VideoCallBookingInformation: ['InProgramVideoCallBookingInformation', 'IntakeVideoCallBookingInformation']
  }
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    AdditionalSignupQuestion: ['AdditionalSignupQuestionSimple'],
    AfterAppLoadScreen: ['AfterAppLoadGetStartedScreen', 'AfterAppLoadSignupFormScreen'],
    AssessmentGraphSeries: ['Gad7Series', 'Phq9Series'],
    AvailableVideoCallSlotsResult: ['AvailableVideoCallSlots', 'VideoCall'],
    CancelPlanForm: ['CancelPlanScreenReasonsToCancel', 'CancelPlanScreenUserFeedback'],
    CancelVideoCallByParticipantResult: ['InAppVideoCallResult'],
    CoachAvailabilityResult: ['CoachAvailability', 'VideoCall'],
    CommunityPost: ['CommunityPostQuestion'],
    CommunityPostReply: ['CommunityPostReplyQuestionAnswer'],
    CommunityPostReplyAuthor: ['CommunityFacilitator'],
    CommunityPostReplyResult: ['CommunityPostReplySended', 'CommunityPostReplySendingPrevented'],
    CostEstimateLookup: ['CostEstimateLookupFailure', 'CostEstimateLookupSuccess'],
    CreateChatMessageResult: ['ChatMessageCreated'],
    EditChatMessageResult: ['ChatMessageEdited'],
    FeedItem: [
      'ChatMessage',
      'LabOrderEvent',
      'OverdueQuestionnaire',
      'PatientResponse',
      'ResumedPatientResponse',
      'SmsMessage',
      'VideoCall',
    ],
    FeedResult: ['FeedSuccess'],
    InAppCancelPlanResult: ['InAppCancelPlanScreen', 'InAppPlanCancelledScreen'],
    InAppCostEstimateComponent: [
      'InAppCostEstimateAlertComponent',
      'InAppCostEstimateExpandableComponent',
      'InAppCostEstimateFeeGroupComponent',
      'InAppCostEstimateHorizontalDividerComponent',
      'InAppCostEstimateIconTextListComponent',
      'InAppCostEstimateMultiTextInRowComponent',
      'InAppCostEstimateParagraphComponent',
      'InAppCostEstimateTimelineComponent',
      'InAppCostEstimateTitleComponent',
    ],
    InAppPaymentInformation: ['AllPaymentsCompleted', 'PaymentSummary', 'UpcomingPayment'],
    InAppProfileFormInputField: [
      'InAppProfileFormCheckbox',
      'InAppProfileFormMultiItemSelector',
      'InAppProfileFormProviderIdentifier',
      'InAppProfileFormSingleItemSelector',
      'InAppProfileFormTextInput',
    ],
    InAppProfileFormItemSelector: [
      'InAppProfileFormMultiItemSelector',
      'InAppProfileFormProviderIdentifier',
      'InAppProfileFormSingleItemSelector',
    ],
    InAppPromptActionPanelActionButton: ['InAppPromptActionPanelActionButtonDeepLink'],
    InAppSignupFormResult: ['InAppSignupFormFound', 'InAppSignupFormNotFound'],
    MarkChatMessagesAsSeenResult: ['UnseenChatMessages'],
    ParticipantRegistrationResult: ['ParticipantRegistered', 'ParticipantRegistrationFailed'],
    PatientHistory: [
      'CommonPatientHistory',
      'FinancialEligibilityPatientHistory',
      'LabOrderPatientHistory',
      'VideoCallPatientHistory',
    ],
    PatientResponseSectionEntryContext: ['PatientResponseSectionEntryContextSingleChoice'],
    PaymentMethod: ['PaymentMethodCreditCard'],
    RescheduleVideoCallByParticipantResult: ['OpenScheduleVideoCallLesson'],
    ScheduleVideoCallByParticipantResult: ['VideoCall', 'VideoCallSlotTaken'],
    SignupFormInput: [
      'SignupFormConsents',
      'SignupFormDateSelector',
      'SignupFormEmailInput',
      'SignupFormItemSelector',
      'SignupFormPhoneNumberInput',
      'SignupFormTextInput',
    ],
    SignupFormScreen: ['SignupFormIsDependentScreen', 'SignupFormRegularScreen'],
    StorePaymentMethodResult: ['StorePaymentMethodResultSuccess'],
    VideoCallBookingInformation: ['InProgramVideoCallBookingInformation', 'IntakeVideoCallBookingInformation'],
  },
}
export default result
